import { createContext, useContext, useState, useEffect, useCallback } from "react";

const LibraryContext = createContext({
  fabrics: [],
  linings: [],
  tshirtFabrics: [],
  isReady: false,
  refresh: () => {},
  refreshFabrics: () => {},
  refreshLinings: () => {},
  refreshTshirtFabrics: () => {},
});

export function LibraryProvider({ children }) {
  const baseUrl = process.env.REACT_APP_API_URL;
  const [fabrics, setFabrics] = useState([]);
  const [linings, setLinings] = useState([]);
  const [tshirtFabrics, setTshirtFabrics] = useState([]);
  const [isReady, setIsReady] = useState(false);

  const fetchFabrics = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return [];
    try {
      const res = await fetch(`${baseUrl}/api/fabrics`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return [];
      const json = await res.json();
      const data = Array.isArray(json.data) ? json.data : [];
      setFabrics(data);
      return data;
    } catch {
      return [];
    }
  }, [baseUrl]);

  const fetchLinings = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return [];
    try {
      const res = await fetch(`${baseUrl}/api/linings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return [];
      const json = await res.json();
      const data = Array.isArray(json.data) ? json.data : [];
      setLinings(data);
      return data;
    } catch {
      return [];
    }
  }, [baseUrl]);

  const fetchTshirtFabrics = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return [];
    try {
      const res = await fetch(`${baseUrl}/api/tshirtFabrics`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return [];
      const json = await res.json();
      const data = Array.isArray(json.data) ? json.data : [];
      setTshirtFabrics(data);
      return data;
    } catch {
      return [];
    }
  }, [baseUrl]);

  const refresh = useCallback(async () => {
    await Promise.all([fetchFabrics(), fetchLinings(), fetchTshirtFabrics()]);
    setIsReady(true);
  }, [fetchFabrics, fetchLinings, fetchTshirtFabrics]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <LibraryContext.Provider
      value={{
        fabrics,
        linings,
        tshirtFabrics,
        isReady,
        refresh,
        refreshFabrics: fetchFabrics,
        refreshLinings: fetchLinings,
        refreshTshirtFabrics: fetchTshirtFabrics,
      }}
    >
      {children}
    </LibraryContext.Provider>
  );
}

export const useLibrary = () => useContext(LibraryContext);
